import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import { DevAlert } from '../index';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function PaginationPanel() {
  const classes = useStyles();
  const [devAlert, setDevAlert] = React.useState(false);

  return (
    <>
      <div className={classes.root}>
        <Pagination
          count={10}
          variant="outlined"
          shape="rounded"
          onClick={() => setDevAlert(true)}
        />
      </div>
      <DevAlert isOpen={devAlert} callBack={() => setDevAlert(false)} />
    </>
  );
}
